import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import OnTraccrButton from '../buttons/OnTraccrButton';
import DisplayText from '../text/DisplayText';
import colors from '../../constants/Colors';

export default function SearchNotFound({
  searchTerm = '',
  onClearSearch,
  onAddNew,
  title = 'results',
  addDisabled = false,
}) {
  return (
    <Row
      style={{
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        width: '100%',
        height: '100%',
      }}
      justify="center"
      align="middle"
    >
      <SearchOutlined style={{ fontSize: 64, marginBottom: 12 }} />
      <DisplayText
        title={`No ${title} found`}
        style={{
          fontSize: 20,
          fontWeight: 600,
          color: colors.REDESIGN_PRIMARY_TEXT,
          fontFamily: 'open-sans, sans-serif',
          marginBottom: 12,
        }}
      />
      <DisplayText
        title="Can't find what you were looking for. Try adjusting your search and try again."
        style={{
          fontSize: 14,
          color: colors.REDESIGN_SECONDARY_TEXT,
          fontFamily: 'open-sans, sans-serif',
        }}
      />
      {searchTerm && (
        <DisplayText
          title={`Search term: "${searchTerm}"`}
          style={{
            fontSize: 12,
            color: colors.REDESIGN_DISABLED,
            fontFamily: 'open-sans, sans-serif',
          }}
        />
      )}

      <Row gutter={12} justify="center">
        <Col>
          <OnTraccrButton
            title="Clear search"
            onClick={onClearSearch}
            type="cancel"
          />
        </Col>
        <Col>
          <OnTraccrButton
            title="Create new"
            icon={<PlusOutlined />}
            onClick={onAddNew}
            disabled={addDisabled}
          />
        </Col>
      </Row>
    </Row>
  );
}

SearchNotFound.propTypes = {
  searchTerm: PropTypes.string,
  onClearSearch: PropTypes.func.isRequired,
  onAddNew: PropTypes.func.isRequired,
  title: PropTypes.string,
  addDisabled: PropTypes.bool,
};

SearchNotFound.defaultProps = {
  searchTerm: '',
  title: 'No results found',
  addDisabled: false,
};
